(function(){
  'use strict';

  var NAV = [
    {
      label:'Shop by Device',
      cols:[
        {heading:'iPhone 17',links:[{text:'iPhone 17 Pro Max',url:'/collections/iphone-17-pro-max'},{text:'iPhone 17 Pro',url:'/collections/iphone-17-pro'},{text:'iPhone 17 Air',url:'/collections/iphone-17-air'},{text:'iPhone 17',url:'/collections/iphone-17'}]},
        {heading:'iPhone 16',links:[{text:'iPhone 16 Pro Max',url:'/collections/iphone-16-pro-max'},{text:'iPhone 16 Pro',url:'/collections/iphone-16-pro'},{text:'iPhone 16 Plus',url:'/collections/iphone-16-plus'},{text:'iPhone 16',url:'/collections/iphone-16'}]},
        {heading:'iPhone 15',links:[{text:'iPhone 15 Pro Max',url:'/collections/iphone-15-pro-max'},{text:'iPhone 15 Pro',url:'/collections/iphone-15-pro'},{text:'iPhone 15 Plus',url:'/collections/iphone-15-plus'},{text:'iPhone 15',url:'/collections/iphone-15'}]},
        {heading:'iPhone 14 & Earlier',links:[{text:'iPhone 14 Pro Max',url:'/collections/iphone-14-pro-max'},{text:'iPhone 14 Pro',url:'/collections/iphone-14-pro'},{text:'iPhone 14',url:'/collections/iphone-14'},{text:'iPhone 13 Series',url:'/collections/iphone-13-series'},{text:'iPhone 12 Series',url:'/collections/iphone-12-series'},{text:'iPhone 11 Series',url:'/collections/iphone-11-series'}]},
        {heading:'Android',links:[{text:'Samsung Galaxy',url:'/collections/samsung-cases'}]}
      ]
    },
    {
      label:'Phone Cases',url:'/collections/phone-cases',
      cols:[
        {heading:'Browse All',links:[{text:'All Cases',url:'/collections/phone-cases'},{text:'New Arrivals',url:'/collections/phone-cases?sort_by=created-descending'}]},
        {heading:'By Material',links:[{text:'Clear Cases',url:'/collections/clear-cases'},{text:'Leather Cases',url:'/collections/leather-cases'},{text:'Carbon Fiber',url:'/collections/carbon-fiber-cases'},{text:'Luxury & Designer',url:'/collections/luxury-designer-cases'}]},
        {heading:'By Feature',links:[{text:'MagSafe Cases',url:'/collections/magsafe-cases'},{text:'Fashion & Art',url:'/collections/fashion-art-cases'}]}
      ]
    },
    {
      label:'Carry & Audio',
      cols:[
        {heading:'Carry',links:[{text:'Crossbody & Lanyards',url:'/collections/crossbody-phone-lanyards'},{text:'Wallets',url:'/collections/wallets'},{text:'Stands & Holders',url:'/collections/stands-holders'}]},
        {heading:'Audio & Wearables',links:[{text:'Watch Bands',url:'/collections/watch-bands'},{text:'AirPods Cases',url:'/collections/airpods-cases'},{text:'AirPods & Earbuds',url:'/collections/airpods-earbuds'}]}
      ]
    },
    {
      label:'Power & Protection',
      cols:[
        {heading:'Power',links:[{text:'Chargers',url:'/collections/chargers'},{text:'Car Chargers',url:'/collections/car-chargers'},{text:'Cables',url:'/collections/cables'},{text:'Power Banks',url:'/collections/power-banks'},{text:'MagSafe Accessories',url:'/collections/magsafe-accessories'}]},
        {heading:'Protection',links:[{text:'Screen Protectors',url:'/collections/screen-protectors'},{text:'Camera Protectors',url:'/collections/camera-protectors'}]}
      ]
    },
    {
      label:'New In',
      cols:[
        {heading:'Latest Drops',links:[{text:'Metal Sticker',url:'/collections/3d-sticker-mobile',badge:'New'},{text:'Sticky Patch',url:'/collections/sticky-patch',badge:'Soon'},{text:'Fashion & Art Cases',url:'/collections/fashion-art-cases'},{text:'Crossbody Collection',url:'/collections/crossbody-phone-lanyards'}]}
      ]
    }
  ];

  function esc(s){ return s.replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;'); }

  function buildPanel(item, idx){
    var n = item.cols.length;
    var cols = item.cols.map(function(col){
      var links = col.links.map(function(lk){
        var badge = lk.badge==='New'?'<span class="kmn-badge-new">New</span>':lk.badge==='Soon'?'<span class="kmn-badge-soon">Soon</span>':'';
        return '<a href="'+esc(lk.url)+'" class="kmn-link"><span class="kmn-link-text">'+esc(lk.text)+badge+'</span><span class="kmn-link-arrow">›</span></a>';
      }).join('');
      return '<div class="kmn-col">'+(col.heading?'<span class="kmn-col-label">'+esc(col.heading)+'</span>':'')+links+'</div>';
    }).join('');
    var panel = document.createElement('div');
    panel.className = 'kmn-panel';
    panel.setAttribute('data-kmn-panel', idx);
    panel.innerHTML = '<div class="kmn-panel-inner kmn-panel--cols-'+Math.min(n,5)+'">'+cols+'</div>';
    return panel;
  }

  function init(){
    if (window.innerWidth < 750) return;
    if (document.getElementById('kyarna-desktop-nav-wrap')) return;

    var header = document.querySelector('#header-component, header-component');
    if (!header) return;

    var ul = document.createElement('ul');
    ul.id = 'kyarna-mega-nav';
    ul.setAttribute('role','menubar');
    ul.setAttribute('aria-label','Main navigation');

    var panels = [];

    NAV.forEach(function(item, i){
      var li = document.createElement('li');
      li.className = 'kmn-item';
      li.setAttribute('data-kmn-item', i);
      var hasCols = item.cols && item.cols.length > 0;
      var chevronSvg = '<svg class="kmn-top-chevron" viewBox="0 0 12 8" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round"><path d="M1 1l5 5 5-5"/></svg>';
      if (hasCols){
        var btn = document.createElement('button');
        btn.type='button'; btn.className='kmn-top';
        btn.setAttribute('data-kmn', i);
        btn.setAttribute('aria-expanded','false');
        btn.setAttribute('aria-haspopup','true');
        btn.innerHTML = esc(item.label)+chevronSvg;
        li.appendChild(btn);
        panels.push(buildPanel(item, i));
      } else {
        var a = document.createElement('a');
        a.className='kmn-top'; a.href=item.url||'#'; a.textContent=item.label;
        li.appendChild(a);
        panels.push(null);
      }
      ul.appendChild(li);
    });

    var wrap = document.createElement('div');
    wrap.id = 'kyarna-desktop-nav-wrap';
    wrap.appendChild(ul);
    var headerCols = header.querySelector('.header__column--left, .header__columns');
    if (headerCols) headerCols.appendChild(wrap); else header.appendChild(wrap);

    var backdrop = document.createElement('div');
    backdrop.id = 'kmn-backdrop';
    document.body.appendChild(backdrop);
    panels.forEach(function(p){ if(p) document.body.appendChild(p); });

    function getHeaderBottom(){
      var hdr = document.querySelector('#header-component, header-component');
      return hdr ? Math.ceil(hdr.getBoundingClientRect().bottom) : 60;
    }

    function positionAll(){
      var top = getHeaderBottom();
      panels.forEach(function(p){ if(p) p.style.top = top + 'px'; });
    }

    positionAll();
    window.addEventListener('scroll', positionAll, {passive:true});
    window.addEventListener('resize', positionAll, {passive:true});

    var currentOpen = -1;
    var closeTimer;

    function closeAll(){
      clearTimeout(closeTimer);
      currentOpen = -1;
      document.querySelectorAll('.kmn-item').forEach(function(l){ l.classList.remove('is-open'); });
      document.querySelectorAll('[data-kmn]').forEach(function(b){ b.setAttribute('aria-expanded','false'); });
      panels.forEach(function(p){ if(p) p.classList.remove('is-open'); });
      backdrop.classList.remove('is-open');
    }

    function openItem(idx){
      if (currentOpen === idx) return;
      clearTimeout(closeTimer);
      document.querySelectorAll('.kmn-item').forEach(function(l){ l.classList.remove('is-open'); });
      document.querySelectorAll('[data-kmn]').forEach(function(b){ b.setAttribute('aria-expanded','false'); });
      panels.forEach(function(p){ if(p) p.classList.remove('is-open'); });
      var li = document.querySelector('[data-kmn-item="'+idx+'"]');
      var btn = document.querySelector('[data-kmn="'+idx+'"]');
      var panel = panels[idx];
      if (!li) return;
      li.classList.add('is-open');
      if (btn) btn.setAttribute('aria-expanded','true');
      if (panel){ positionAll(); panel.classList.add('is-open'); backdrop.classList.add('is-open'); }
      currentOpen = idx;
    }

    function cancelClose(){ clearTimeout(closeTimer); }

    /* ─────────────────────────────────────────────────────────────
     MOUSEMOVE APPROACH
     Instead of relying on mouseleave (which fires unreliably
     when the header has extra rows that clip events), we track
     the mouse globally and close only when it leaves BOTH the
     wrap+gap zone AND the open panel.
    ────────────────────────────────────────────────────═──────── */
    function isOverZone(mx, my){
      /* Check wrap bounding rect (includes padding-bottom extension) */
      var wr = wrap.getBoundingClientRect();
      if (mx >= wr.left && mx <= wr.right && my >= wr.top && my <= wr.bottom) return true;
      /* Check open panel */
      if (currentOpen >= 0){
        var p = panels[currentOpen];
        if (p && p.classList.contains('is-open')){
          var pr = p.getBoundingClientRect();
          if (mx >= pr.left && mx <= pr.right && my >= pr.top && my <= pr.bottom) return true;
        }
      }
      return false;
    }

    var moveTimer;
    document.addEventListener('mousemove', function(e){
      clearTimeout(moveTimer);
      moveTimer = setTimeout(function(){
        if (currentOpen < 0) return;
        if (!isOverZone(e.clientX, e.clientY)){
          closeAll();
        }
      }, 80); /* 80ms debounce — smooth but responsive */
    }, {passive: true});

    /* Keep hover open on button hover */
    wrap.addEventListener('mouseover', function(e){
      cancelClose();
      var btn = e.target.closest('[data-kmn]');
      if (btn) openItem(parseInt(btn.getAttribute('data-kmn'), 10));
    });

    /* Click toggle (for touch / keyboard users) */
    wrap.addEventListener('click', function(e){
      var btn = e.target.closest('[data-kmn]');
      if (!btn) return;
      var idx = parseInt(btn.getAttribute('data-kmn'), 10);
      if (currentOpen === idx) closeAll(); else openItem(idx);
    });

    backdrop.addEventListener('click', closeAll);
    document.addEventListener('keydown', function(e){ if(e.key==='Escape') closeAll(); });
  }

  function boot(attempt){
    attempt = attempt || 0;
    if (document.getElementById('kyarna-desktop-nav-wrap')) return;
    if (document.querySelector('#header-component, header-component')){
      init();
    } else if (attempt < 30){
      setTimeout(function(){ boot(attempt+1); }, 200);
    }
  }

  if (document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', function(){ boot(); });
  } else {
    boot();
  }

})();
